import { el } from 'redom';

import TextInputRow from 'generics/components/text-input-row';

import OptionsEditor from '../base';
import RequiredInputRow from '../required-input-row';

import {
  isNumber
} from '../utilities';

class TextFieldOptionsEditor extends OptionsEditor {

  constructor(configuration) {

    super(configuration);

    this.el = el('.text-field-options-editor-main', [
      this.renderPlaceholderInputRow(),
      this.renderRequiredAttributeInputRow(),
      this.renderMinLengthAttributeInputRow(),
      this.renderMaxLengthAttributeInputRow()
    ]);

  }

  renderPlaceholderInputRow() {

    return new TextInputRow({
      label: 'Placeholder',
      placeholder: 'Placeholder text',
      value: this.fieldRow.options.placeholder,
      onChange: this.handlePlaceholderInputChange.bind(this)
    });

  }

  renderRequiredAttributeInputRow() {

    return new RequiredInputRow({
      checked: this.fieldRow.options.required,
      onChange: this.handleRequiredAttributeChange.bind(this)
    });

  }

  renderMinLengthAttributeInputRow() {

    return new TextInputRow({
      type: 'number',
      label: 'Min length',
      placeholder: '5',
      value: this.fieldRow.options.minLength,
      onChange: this.handleMinLengthChange.bind(this)
    });

  }

  renderMaxLengthAttributeInputRow() {

    return new TextInputRow({
      type: 'number',
      label: 'Max length',
      placeholder: '50',
      value: this.fieldRow.options.maxLength,
      onChange: this.handleMaxLengthChange.bind(this)
    });

  }

  handlePlaceholderInputChange(event, placeholder) {

    this.fieldRow.options.placeholder = placeholder;

    this.propogateFieldOptionsChange();

  }

  handleMinLengthChange(event, minLength) {

    if (isNumber(minLength) === true) {
      this.fieldRow.options.minLength = parseInt(minLength, 10);
    } else {
      delete this.fieldRow.options.minLength;
    }

    this.propogateFieldOptionsChange();

  }

  handleMaxLengthChange(event, maxLength) {

    if (isNumber(maxLength) === true) {
      this.fieldRow.options.maxLength = parseInt(maxLength, 10);
    } else {
      delete this.fieldRow.options.maxLength;
    }

    this.propogateFieldOptionsChange();

  }

  handleRequiredAttributeChange(required) {

    this.fieldRow.options.required = required;

    this.propogateFieldOptionsChange();

  }

}

export default TextFieldOptionsEditor;